import { CubePresenter, Logger, NOOP_VOID } from 'wdc-cube';
import { SignInKeys } from '../account/sign-in/auth.key';
import { LandingKeys } from './landing.key';
import { LandingScope } from './landing.scope';
const LOG = Logger.get('Mormaii.LandingPresenter');
/**
 * A pagina de aterrissagem.
 *
 * Publica, sem parametro e sem rede: e a primeira coisa que alguem sem sessao ve, e
 * nao pode depender de servidor nenhum para aparecer.
 *
 * A copia e montada aqui, no `initialize`, e nao lida de arquivo: nesta fase ela
 * muda com a conversa com o cliente, e um lugar so para editar vale mais do que uma
 * indirecao. Se um dia vier de um CMS, e este metodo que passa a busca-la.
 */
export class LandingPresenter extends CubePresenter {
    constructor(app) {
        super(app, new LandingScope());
        this.parentSlot = NOOP_VOID;
    }
    async applyParameters(intent, initialization) {
        const keys = new LandingKeys(this.app, intent);
        if (initialization) {
            this.scope.onSignIn = this.action(this.onSignIn);
            this.fill();
            LOG.info('Initialized');
        }
        // O slot e decidido acima na composicao e pode mudar entre viagens: le-se sempre.
        this.parentSlot = keys.parentSlot;
        this.parentSlot(this.scope);
        return true;
    }
    async onSignIn() {
        await SignInKeys.of(this.app).flip();
    }
    /**
     * A copia.
     *
     * Escrita para QUEM DECIDE a contratacao - a empresa -, e nao para quem usa a
     * pulseira. Quem usa chega pelo app; quem chega aqui esta avaliando se coloca
     * isto para a equipe dele.
     */
    fill() {
        const scope = this.scope;
        scope.headline = 'A saúde da sua equipe, em números que você entende';
        scope.subheadline =
            'A pulseira mede o dia inteiro. O painel transforma isso em quem está bem, ' +
                'quem precisa de atenção e o que mudou desde o mês passado.';
        scope.promise =
            'Sono, coração, pressão e atividade de cada pessoa - reunidos, comparáveis e ' +
                'com faixas que a sua equipe de saúde define.';
        scope.signInLabel = 'Entrar';
        scope.contactLabel = 'Falar com a gente';
        /*
         * VAZIO de proposito, e o botao some enquanto estiver.
         *
         * O "Criar conta" saiu daqui porque nao ha autoatendimento no modelo que o
         * cliente definiu. O que entra no lugar e contato comercial - e o endereco e
         * dele, nao nosso. Inventar um seria publicar um canal que ninguem le.
         */
        scope.contactEmail = '';
        scope.metricsTitle = 'O que é acompanhado';
        scope.metrics = [
            { icon: 'sleep', label: 'Sono', hint: 'duração e estágios' },
            { icon: 'heart', label: 'Frequência cardíaca', hint: 'em repouso e em atividade' },
            { icon: 'hrv', label: 'Variabilidade cardíaca', hint: 'o sinal de recuperação' },
            { icon: 'pressure', label: 'Pressão arterial', hint: 'sistólica e diastólica' },
            { icon: 'oxygen', label: 'Oxigenação', hint: 'saturação em %' },
            { icon: 'temperature', label: 'Temperatura', hint: 'variação corporal' },
            { icon: 'steps', label: 'Passos e distância', hint: 'o movimento do dia' },
            { icon: 'energy', label: 'Gasto calórico', hint: 'esforço acumulado' }
        ];
        scope.stepsTitle = 'Como funciona';
        scope.stepsSubtitle = 'Três passos, e nenhum deles é instalar servidor.';
        scope.steps = [
            {
                title: 'A equipe recebe o dispositivo',
                text: 'Pulseira ou anel. Cada pessoa instala o aplicativo, informa o CNPJ da ' +
                    'empresa e passa a aparecer no painel.'
            },
            {
                title: 'As medições chegam sozinhas',
                text: 'Do pulso para o aplicativo, do aplicativo para a plataforma. Ninguém ' +
                    'digita nada, e o histórico começa no primeiro dia.'
            },
            {
                title: 'Vocês definem o que é normal',
                text: 'As faixas de cada indicador são suas - por empresa ou por pessoa. É o ' +
                    'que decide quem aparece em atenção na lista.'
            }
        ];
        scope.features = [
            {
                eyebrow: 'Para quem coordena',
                title: 'A lista abre por quem precisa de atenção',
                text: 'A coluna de atenção ordena a tela sozinha. Quem está fora das faixas ' +
                    'vem primeiro, com a última medição de cada indicador ao lado do nome.',
                bullets: [
                    'Filtro por nome, CPF, empresa, indicador e faixa',
                    'A ordenação e o filtro ficam no endereço - o link leva o recorte junto',
                    'Cada linha abre a ficha completa da pessoa'
                ]
            },
            {
                eyebrow: 'Para quem acompanha',
                title: 'A ficha de uma pessoa, dia a dia',
                text: 'Médias do período, curvas por indicador e a lista de medições de cada ' +
                    'dia - com a origem de cada leitura e a faixa em que ela caiu.',
                bullets: [
                    'Semana, mês ou um dia específico',
                    'Limites próprios, quando a pessoa foge do padrão da empresa',
                    'Histórico compartilhável por link, com prazo de validade'
                ]
            },
            {
                eyebrow: 'Para quem presta contas',
                title: 'Relatórios que já saem prontos',
                text: 'O relatório de sono monta seis tabelas do grupo que você escolher, no ' +
                    'período que você escolher, e desce em PDF pronto para circular.',
                bullets: [
                    'Seleções de pessoas salvas e reutilizáveis',
                    'Períodos comuns a um clique, ou o intervalo que você digitar',
                    'Adoção e engajamento: adesão, atividade e evolução'
                ]
            }
        ];
        /*
         * ATENCAO: estes tres depoimentos sao INVENTADOS.
         *
         * Nao vieram de cliente nenhum - foram escritos para ocupar o lugar da prova
         * social que a referencia visual tem, e existem so para o cliente ver o
         * DESENHO da secao. Depoimento inventado numa pagina publica e declaracao
         * falsa: antes de esta pagina sair do `localhost`, ou eles viram reais (com
         * autorizacao de quem falou) ou a secao inteira sai.
         *
         * Item 6 de `.claude/docs/validar-com-cliente.md`.
         */
        scope.voicesTitle = 'Quem já acompanha assim';
        scope.voices = [
            {
                quote: 'A gente via exame uma vez por ano. Agora vê a tendência antes de o ' + 'exame acontecer.',
                who: 'Coordenação de saúde ocupacional',
                role: 'Indústria, 340 colaboradores'
            },
            {
                quote: 'O relatório de sono virou pauta fixa da reunião de segunda. Antes ' +
                    'ninguém tinha o número para discutir.',
                who: 'Departamento médico',
                role: 'Clube esportivo'
            },
            {
                quote: 'O que mudou não foi o dado. Foi conseguir olhar para ele sem montar planilha.',
                who: 'Recursos humanos',
                role: 'Rede de varejo'
            }
        ];
        scope.closingTitle = 'O dispositivo coleta. A plataforma faz valer.';
        scope.closingText =
            'Entre para ver o painel da sua empresa, ou crie a conta do profissional que vai ' + 'acompanhar a equipe.';
    }
}
//# sourceMappingURL=landing.presenter.js.map